import React from 'react';
import { CalculationHourlyRateSettingsSection } from './CalculationHourlyRateSettingsSection';
import { LaborCostShareSettingsSection } from './LaborCostShareSettingsSection';
import { LegalAttachmentsSettingsSection } from './LegalAttachmentsSettingsSection';
import { PaymentConditionsSettingsSection } from './PaymentConditionsSettingsSection';
import { DunningSettingsSection } from './DunningSettingsSection';
import { IncomingInvoiceMailboxSettingsCard } from './IncomingInvoiceMailboxSettingsCard';
import { ConstructionDeductionsSettingsSection } from './ConstructionDeductionsSettingsSection';
import { IncomingApprovalSettingsSection } from './InvoiceComplianceSettingsSection';
import { useModuleAccess } from '../../../hooks/useModuleAccess';
import { type InstanceModuleMap, isModuleEnabled } from '../../../lib/instanceModules';

/**
 * Name der Settings-Seite je nach gebuchten Modulen (Angebotspaket ohne Rechnungen und umgekehrt).
 * null: weder Angebote noch Rechnungen, die Seite verschwindet.
 */
export function offersInvoicesSettingsLabel(modules: Partial<InstanceModuleMap> | null | undefined): string | null {
  const angebote = isModuleEnabled(modules, 'angebote');
  const rechnungen = isModuleEnabled(modules, 'rechnungen');
  if (angebote && rechnungen) return 'Angebote & Rechnungen';
  if (angebote) return 'Angebote';
  if (rechnungen) return 'Rechnungen';
  return null;
}

export function OffersInvoicesSettingsSection() {
  // Karten eines Moduls erst zeigen, wenn der Modulstand geladen ist (kein Aufblitzen, keine 403).
  // Zahlungsziel und Lohnkostenanteil gelten für beide; sie zeigen nur die Teile gebuchter Module.
  const { loaded: modulesLoaded, isEnabled } = useModuleAccess();
  const angebote = modulesLoaded && isEnabled('angebote');
  const rechnungen = modulesLoaded && isEnabled('rechnungen');
  return (
    <div className="-mx-3 -mt-3 md:mx-0 md:mt-0 space-y-3 md:space-y-5">
      {rechnungen ? <IncomingInvoiceMailboxSettingsCard /> : null}
      {rechnungen ? <IncomingApprovalSettingsSection /> : null}
      <PaymentConditionsSettingsSection showOffers={angebote} showInvoices={rechnungen} />
      {rechnungen ? <ConstructionDeductionsSettingsSection /> : null}
      {rechnungen ? <DunningSettingsSection /> : null}
      {/* Kalkulation gilt im Angebots- und im Rechnungseditor. */}
      {angebote || rechnungen ? <CalculationHourlyRateSettingsSection /> : null}
      <LaborCostShareSettingsSection showOffers={angebote} showInvoices={rechnungen} />
      {angebote ? <LegalAttachmentsSettingsSection /> : null}
    </div>
  );
}
